import { render } from "./WorldMap.vue?vue&type=template&id=6b6cea68&scoped=true"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"

import "./WorldMap.vue?vue&type=style&index=0&id=6b6cea68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6cea68"]])

export default __exports__